<table class="table" *ngIf="licenses.length">
  <thead>
    <tr>
      <th>State</th>
      <th>Number</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let license of licenses">
      <td>{{ license.state }}</td>
      <td>{{ license.number }}</td>
      <td>
        <button textCta class="mr-2" (click)="editLicense($event, license)">Edit</button>
        <button textCta class="mr-2" (click)="confirmRemoveLicense($event, license)">Delete</button>
      </td>
    </tr>
  </tbody>
</table>

<div>
  <button class="btn btn-primary" (click)="addLicense($event)">Add</button>
</div>

<div #licenseModal="bs-modal" bsModal class="nested-tab-modal modal fade">
  <div class="modal-dialog" *ngIf="this.selectedLicense">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ selectedLicense.id ? 'Edit License' : 'New License' }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="licenseModal.hide()">
          <fa aria-hidden="true" name="times-circle"></fa>
        </button>
      </div>
      <div class="modal-body">
        <form #licenseForm="ngForm">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="state" class="form-control-label">State</label>
                <select class="form-control " name="state" [(ngModel)]="selectedLicense.state">
                  <option value=""></option>
                  <option value="AK">AK</option>
                  <option value="AL">AL</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="ND">ND</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VA">VA</option>
                  <option value="VT">VT</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="number" class="form-control-label">Number</label>
                <input required type="text" name="number" class="form-control" [(ngModel)]="selectedLicense.number" />
              </div>
            </div>
          </div>
          <button class="btn btn-primary" [disabled]="licenseForm.invalid" (click)="saveLicense($event)">Save</button>
        </form>
      </div>
    </div>
  </div>
</div>

<swal #confirm title="Are you sure?" type="warning" text="Deleting a license cannot be undone." [swalOptions]="{ showCancelButton: true }" (confirm)="removeLicense()"></swal>
